import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AccountsService } from '../../../services/identity/accounts.service';
import { AuthenticatedUser } from '../../../models/identity/authenticated-user.model';
import { PermissionsService } from '../../../services/shared/permissions.service';

@Component({
    selector: 'app-home-page',
    styleUrls: ['./home-page.component.scss'],
    templateUrl: './home-page.component.html',
})
export class HomePageComponent implements OnInit {
    scoopItTopics: any[] | undefined;
    topicSelected: any | undefined;
    idTopicSelected: number;

    public currentUser: AuthenticatedUser;

    urlScoopItAdmin: string | undefined;

    constructor(private readonly accountsService: AccountsService, private readonly roleService: PermissionsService) {}

    ngOnInit() {
        this.currentUser = this.accountsService.currentUser;

        this.scoopItTopics = this.getUserScoopItTopics(environment.scoopItTopics);
        if (this.scoopItTopics != undefined) {
            this.selectMainCommunityTopic();
            this.topicSelected = this.getSelectedTopic();
            if (this.topicSelected != undefined) this.idTopicSelected = this.topicSelected.idTopic;
        }
        this.urlScoopItAdmin = environment.scoopItAdminUrl;
    }

    getSelectedTopic(): any {
        for (var topic of this.scoopItTopics) {
            if (topic.selected == true) return topic;
        }
        if (this.topicSelected && this.topicSelected[0]) return this.topicSelected[0];

        return undefined;
    }

    updateSelectedTopic(): any {
        for (var i = 0; i < this.scoopItTopics.length; i++) {
            if (this.scoopItTopics[i].idTopic == this.idTopicSelected) {
                this.scoopItTopics[i].selected = true;
            } else {
                this.scoopItTopics[i].selected = false;
            }
        }
        this.topicSelected = this.getSelectedTopic();
    }

    ngModelChange(event: any) {
        this.idTopicSelected = event;
        this.updateSelectedTopic();
    }
    getUserScoopItTopics(scoopItTopics: any[]): any[] {
        var scoopItTopicsArray = [];

        for (var topic of scoopItTopics) {
            if (
                topic.isPublic ||
                (topic.idCommunautes?.length && this.accountsService.isInCommunities(topic.idCommunautes))
            )
                scoopItTopicsArray.push(topic);
        }

        return scoopItTopicsArray?.sort((a, b) => a.nameTopic.localeCompare(b.nameTopic));
    }
    isUserCommunityInfluencer(idCommunities: Array<{ id: string; default: boolean }>): boolean {
        if (idCommunities?.length > 0)
            for (const idCommunity of idCommunities)
                if (this.roleService.isUserCommunityInfluencer(idCommunity.id)) return true;
        return false;
    }

    selectMainCommunityTopic() {
        for (var topic of this.scoopItTopics) {
            if (topic.idCommunautes?.length > 0) {
                for (var topicCommunityId of topic.idCommunautes) {
                    if (topicCommunityId.id == this.currentUser.primaryCommunity.id && topicCommunityId.default) {
                        topic.selected = true;

                        if (topic.seePublicTopics == false) {
                            this.scoopItTopics = this.scoopItTopics.filter(
                                (topic) => !topic.isPublic || this.accountsService.isInCommunities(topic.idCommunautes),
                            );
                        }

                        return;
                    }
                }
            }
        }

        if (this.scoopItTopics.length > 0) this.scoopItTopics[0].selected = true;
    }
}
